import {IUserInformationsWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {CerbaAuthService} from "@digicerba/common";

@Injectable()
export class AccessResolver implements Resolve<Boolean> {

  constructor(private iUserInformationsWebServiceClient: IUserInformationsWebServiceClient, private cerbaAuthService: CerbaAuthService) {
  }

  resolve() {
    let checkCall = this.iUserInformationsWebServiceClient.checkAccess();
    checkCall.subscribe(allowed => {
    }, (error) => {
      this.cerbaAuthService.unauthorized(error.status);
    });
    return checkCall;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-factures/digicerba-factures-web/src/angular/cerba/src/app/pages/cerba/check.resolver.ts